import React, { FunctionComponent } from "react";
import { Grid, Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { styled } from "@mui/material/styles";

interface IUseStyleProps {
  invalid: boolean;
}

interface IStyledTooltipProps extends IUseStyleProps {
  title: string;
}

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))<IStyledTooltipProps>(({ theme, invalid }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "var(--kyocera-white)",
    fontSize: "0.75rem",
    maxWidth: "unset",
    color: invalid ? "var(--kyocera-red)" : "var(--kyocera-green)",
    "& .MuiSvgIcon-root": {
      fontSize: "1.05rem",
    },
    marginTop: '0 !important',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "var(--kyocera-background-grey)"
  },
}));

const StyledTooltipIcon = styled("div")<IUseStyleProps>(({ invalid }) => ({
  display: "block",
  color: invalid ? "var(--kyocera-red)" : "var(--kyocera-green)",
}));

export const StyledTooltip: FunctionComponent<TooltipProps & IStyledTooltipProps> = ({
  children,
  invalid,
  title,
  ...rest
}) => {
  const tooltipTitle = (
    <Grid container spacing={1} alignItems="center" direction="row" wrap="nowrap">
      <Grid item>
        {invalid ? (
          <StyledTooltipIcon invalid={invalid}>
            <ErrorIcon />
          </StyledTooltipIcon>
        ) : (
          <StyledTooltipIcon invalid={invalid}>
            <CheckCircleIcon />
          </StyledTooltipIcon>
        )}
      </Grid>
      <Grid item>{title}</Grid>
    </Grid>
  ) as unknown as string; // Type assertion to resolve type mismatch

  return (
    <CustomTooltip
      title={tooltipTitle}
      placement="bottom-end"
      {...rest}
      invalid={invalid}
      PopperProps={{
        modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 0], // Adjusts vertical offset (8px instead of 14px)
              },
            },
          ],
      }}
    >
      {children}
    </CustomTooltip>
  );
};
